function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtboard6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.88899,
    height: 62.98647,
    viewBox: "0 0 57.88899 62.98647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M55.88902,40.9903V21.9903c.00003-3.74887-2.00018-7.21292-5.24701-9.08701L34.19102,3.4033c-3.24673-1.87497-7.24725-1.87497-10.49399,0L7.24603,12.9033c-3.24644,1.87433-5.24625,5.33835-5.246,9.08701v19c-.00003,3.74887,2.00017,7.21292,5.24699,9.08701l16.45099,9.5c3.24673,1.87497,7.24725,1.87497,10.49399,0l16.45099-9.5c3.24646-1.87433,5.24628-5.33832,5.24603-9.08701",
    style: {
      fill: "#c75d5d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M55.88899,40.99323V21.99323c.00003-3.74887-2.00018-7.21292-5.24701-9.08701L34.19099,3.40623c-3.24673-1.87497-7.24725-1.87497-10.49399,0L7.246,12.90623c-3.24644,1.87433-5.24625,5.33835-5.246,9.08701v19c-.00003,3.74887,2.00017,7.21292,5.24699,9.08701l16.45099,9.5c3.24673,1.87497,7.24725,1.87497,10.49399,0l16.45099-9.5c3.24646-1.87433,5.24628-5.33832,5.24603-9.08701Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M18.76202,44.6633c-.6446,.01614-1.27411-.19642-1.777-.6h-.037c-.45163-.33378-.72806-.85393-.752-1.415,.04111-.65638,.29213-1.28216,.716-1.785,.44633-.60848,1.02528-1.10741,1.693-1.459,.68772-.37212,1.45609-.57022,2.238-.577,.65477-.00179,1.3008,.15029,1.886,.444,0-.038,.005-.07,.008-.1,.031-.41,.047-.616,.047-8.824v-9l5.3-1.024c3.057-.594,5.894-1.18,6.53-1.335,.669-.163,1.685-.384,2.25-.475l1.043-.183v14.457c.011,5.786,.011,6.258-.37,6.884-.84885,1.29829-2.228,2.15515-3.768,2.341-.12,.009-.237,.014-.348,.014-.6703,.00766-1.32491-.20293-1.865-.6-.3465-.28116-.58904-.67012-.689-1.105-.07989-.41373-.03928-.84168,.117-1.233,.3674-.86392,.98577-1.59761,1.775-2.106,.82153-.58333,1.79782-.90945,2.805-.937,.32658-.00128,.65174,.04315,.966,.132,.29143,.08702,.57141,.20855,.834,.362h.007l.073-7.353c.052-6.09,.022-6.549-.013-7.082l-.006-.088c-.243,.047-.7,.141-1.271,.26-1.021,.211-2.418,.5-3.941,.8-1.2,.209-2.678,.492-4.1,.765-1.7,.326-3.455,.663-4.786,.881l-.01401,8.78699-.036,7.5c-.03034,.91067-.47482,1.75765-1.207,2.3-.91457,.81765-2.0826,1.29574-3.30799,1.354Z",
    style: {
      fill: "#914444"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard6);
export default __webpack_public_path__ + "static/media/Artboard_6.dec4ede9f86e1f86ea6c21a01219a7ff.svg";
export { ForwardRef as ReactComponent };